import React, { useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useReactToPrint } from 'react-to-print';
import { dateFormatterShort } from '../../../utils/general';

function Printable({showModal, handleCloseModal,selectedRequest}) {

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: 'اعتماد عريضة',
    onAfterPrint: () => console.log('Printed PDF successfully!'),
   });

   const handleCloseAndPrint = () => {
    handleCloseModal()
    handlePrint()
   }

  return (
    <Modal show={showModal} onHide={handleCloseModal} size="lg" scrollable>
        <Modal.Header className='bg-dark'>
          <Modal.Title className='fs-5 text-white mb-0'>تفاصيل الاعتماد</Modal.Title>
          <Button variant="light" className="mb-0" size="sm" onClick={handleCloseModal} aria-label="Close"><i class="bi bi-x-lg"></i></Button>
        </Modal.Header>
        <Modal.Body>

        <div
    className="modal-body p-4"
    ref={componentRef}
    style={{ width: '100%', height: window.innerHeight }}
   >
    <h1 style={{textAlign:'center'}} >اعتماد عريضة</h1>
    
    <div className='mt-3' style={{
      width: '80%',
      height: '80%',
      margin: 'auto',
      textAlign: 'right',
  }}>

    <div className='bg-secondary bg-opacity-10  border-secondary rounded-3 p-3 pb-1 my-3'>
        <h6 class="mb-3"> رقم العريضة</h6>
        <p class="mb-3">{selectedRequest?.id}</p>
    </div>


    {selectedRequest?.managerapproval?.approved_date ? 
    <div className='bg-secondary bg-opacity-10  border-secondary rounded-3 p-3 pb-1 my-3'>
              <h6 class="mb-3">تاريخ الاعتماد</h6>
              <p class="mb-3">{dateFormatterShort.format(Date.parse(selectedRequest?.managerapproval?.approved_date))}</p>

          </div>
          :null}

    <div className='bg-secondary bg-opacity-10  border-secondary rounded-3 p-3 pb-1 my-3'>
              <h6 class="mb-3">المبلغ المعتمد</h6>
              <p class="mb-3">{selectedRequest?.managerapproval?.amount}</p>

          </div>

    <div className='bg-secondary bg-opacity-10  border-secondary rounded-3 p-3 pb-1 my-3'>
              <h6 class="mb-3">الملاحظات</h6>
              <p class="mb-3">{selectedRequest?.managerapproval?.approval_notice}</p>

          </div>

    <div className='bg-secondary bg-opacity-10  border-secondary rounded-3 p-3 pb-1 my-3'>
              <h6 class="mb-3">توقيع المدير</h6>
              <p class="mb-3">خليفة محمد الربان</p>

          </div>

    

    

    </div>
   </div>


				


        </Modal.Body>
        <Modal.Footer>
          <Button className='my-0' variant="primary-soft" onClick={handleCloseAndPrint}>
          طباعة
          </Button>
        </Modal.Footer>
      </Modal>
    
  )
}

export default Printable